const errmsg = state => {
    return (state && state.errmsg) || ''
}
const changing = state => {
    return state.changing || ''
}
const changeState = state => {
    return state.changeState || {}
}
const sending = state => {
    return state.sending || ''
}
const sendState = state => {
    return state.sendState || {}
}
const checking = state => {
    return state.checking || ''
}
const checkState = state => {
    return state.checkState || {}
}
const loadingP = state => {
    return state.loadingP || ''
}
const pOrderList = state => {
    return state.pOrderList || {}
}
const loadingR = state => {
    return state.loadingR || ''
}
const rOrderList = state => {
    return state.rOrderList || {}
}
const relateReturn = state => {
    return state.relateReturn || {}
}
const relateStatus = state => {
    return state.relateStatus || ''
}
const updateReturn = state => {
    return state.updateReturn || {}
}
const updateStatus = state => {
    return state.updateStatus || ''
}
const awReturn = state => {
    return state.awReturn || {}
}
const awStatus = state => {
    return state.awStatus || ''
}
const inheritData = state => {
    return state.inheritData || {}
}
const inheStatus = state => {
    return state.inheStatus || ''
}
const logCode = state => {
    return state.logCode || {}
}
const lcLoading = state => {
    return state.lcLoading || ''
}
const whiteList = state => {
    return state.whiteList || {}
}
const wlLoading = state => {
    return state.wlLoading || ''
}
export default {
    errmsg,
    logCode,
    lcLoading,
    whiteList,
    wlLoading,
    inheritData,
    inheStatus,
    changing,
    changeState,
    sendState,
    sending,
    checkState,
    checking,
    pOrderList,
    loadingP,
    rOrderList,
    loadingR,
    relateReturn,
    relateStatus,
    updateReturn,
    updateStatus,
    awReturn,
    awStatus
}